import { StoreContext } from './constant';
import { initStore } from './index';

export function StoreProvider({ children }: { children: React.ReactNode }) {
  const store = initStore();

  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}
